import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-flex-none"
}
const _hoisted_2 = { class: "tw-mb-1 tw-block tw-text-xs dark:tw-text-white" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-border-b tw-text-xs" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "1.", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "2.", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "3.", -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "tw-m-1 tw-inline-flex tw-divide-x tw-rounded tw-border tw-text-2xs" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "tw-m-1 tw-inline-flex tw-divide-x tw-rounded tw-border tw-text-2xs" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListBullet = _resolveComponent("ListBullet")!
  const _component_Hyperlink = _resolveComponent("Hyperlink")!
  const _component_TablerAlignLeft = _resolveComponent("TablerAlignLeft")!
  const _component_TablerAlignCenter = _resolveComponent("TablerAlignCenter")!
  const _component_TablerAlignRight = _resolveComponent("TablerAlignRight")!
  const _component_TablerAlignJustified = _resolveComponent("TablerAlignJustified")!
  const _component_EditorContent = _resolveComponent("EditorContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "tw-overflow-hidden tw-rounded-md tw-border tw-bg-white focus-within:tw-border-deep-orange-500 focus-within:tw-ring-1 focus-within:tw-ring-deep-orange-500 hover:tw-ring-1 hover:tw-ring-deep-orange-500 dark:tw-bg-black",
      onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.focusEditor && _ctx.focusEditor(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          "data-testid": "toggle-editor-heading-variant-button",
          class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-border-r tw-font-bold", { 'tw-text-blue-500': _ctx.showHeadingVariantButtons }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showHeadingVariantButtons = !_ctx.showHeadingVariantButtons))
        }, " H ", 2),
        _createElementVNode("button", {
          "data-testid": "toggle-editor-bold-button",
          disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleBold().run()),
          class: _normalizeClass({
            'tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-border-r tw-font-bold': true,
            'tw-text-deep-orange-500': _ctx.editor && _ctx.editor.isActive('bold')
          }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().toggleBold().run()))
        }, " B ", 10, _hoisted_4),
        _createElementVNode("button", {
          "data-testid": "toggle-editor-italic-button",
          disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleItalic().run()),
          class: _normalizeClass({
            'tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-border-r tw-font-bold tw-italic': true,
            'tw-text-deep-orange-500': _ctx.editor && _ctx.editor.isActive('italic')
          }),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().toggleItalic().run()))
        }, " i ", 10, _hoisted_5),
        _createElementVNode("button", {
          "data-testid": "toggle-editor-strike-button",
          disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleStrike().run()),
          class: _normalizeClass({
            'tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-border-r tw-line-through': true,
            'tw-text-deep-orange-500': _ctx.editor && _ctx.editor.isActive('strike')
          }),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().toggleStrike().run()))
        }, " S ", 10, _hoisted_6),
        _createElementVNode("button", {
          "data-testid": "toggle-editor-unordered-list-button",
          class: _normalizeClass({
            'tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-border-r': true,
            'tw-text-deep-orange-500': _ctx.editor && _ctx.editor.isActive('bulletList')
          }),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().toggleBulletList().run()))
        }, [
          _createVNode(_component_ListBullet, { class: "tw-h-4 tw-w-4" })
        ], 2),
        _createElementVNode("button", {
          "data-testid": "toggle-editor-ordered-list-button",
          class: _normalizeClass({
            'tw-inline-flex tw-h-8 tw-w-8 tw-flex-col tw-items-center tw-justify-center tw-border-r tw-text-[5px] tw-font-bold tw-leading-none': true,
            'tw-text-deep-orange-500': _ctx.editor && _ctx.editor.isActive('orderedList')
          }),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().toggleOrderedList().run()))
        }, _hoisted_10, 2),
        _createElementVNode("button", {
          "data-testid": "toggle-editor-dash-button",
          class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-flex-col tw-items-center tw-justify-center tw-border-r tw-text-[5px] tw-font-bold tw-leading-none", {
            'tw-text-blue-500': _ctx.editor && _ctx.editor.isActive('horizontalRule')
          }]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().setHorizontalRule().run()))
        }, " — ", 2),
        (_ctx.editor && !_ctx.editor.isActive('link'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              "data-testid": "toggle-editor-set-link-button",
              class: _normalizeClass({
            'tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-border-r': true,
            'tw-text-deep-orange-500': _ctx.editor && _ctx.editor.isActive('link')
          }),
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setLink && _ctx.setLink(...args)))
            }, [
              _createVNode(_component_Hyperlink, { class: "tw-h-4 tw-w-4" })
            ], 2))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              "data-testid": "toggle-editor-unset-link-button",
              class: _normalizeClass({
            'tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-border-r': true,
            'tw-text-deep-orange-500': _ctx.editor && _ctx.editor.isActive('link')
          }),
              onClick: _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editor as Editor).chain().focus().unsetLink().run()))
            }, [
              _createVNode(_component_Hyperlink, { class: "tw-h-4 tw-w-4" })
            ], 2)),
        _createElementVNode("button", {
          "data-testid": "toggle-editor-text-align-variant-button",
          class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-border-r tw-font-bold", { 'tw-text-blue-500': _ctx.showTextAlignVariantButtons }]),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showTextAlignVariantButtons = !_ctx.showTextAlignVariantButtons))
        }, [
          _createVNode(_component_TablerAlignLeft, { class: "tw-h-4 tw-w-4" })
        ], 2)
      ]),
      (_ctx.showHeadingVariantButtons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                "data-testid": "toggle-editor-heading-1-button",
                disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleHeading({ level: 1 }).run()),
                class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-font-bold", {
              'tw-text-blue-500': _ctx.editor && _ctx.editor.isActive('heading', { level: 1 })
            }]),
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().toggleHeading({ level: 1 }).run()))
              }, " h1 ", 10, _hoisted_13),
              _createElementVNode("button", {
                "data-testid": "toggle-editor-heading-2-button",
                disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleHeading({ level: 2 }).run()),
                class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-font-bold", {
              'tw-text-blue-500': _ctx.editor && _ctx.editor.isActive('heading', { level: 2 })
            }]),
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().toggleHeading({ level: 2 }).run()))
              }, " h2 ", 10, _hoisted_14),
              _createElementVNode("button", {
                "data-testid": "toggle-editor-heading-3-button",
                disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleHeading({ level: 3 }).run()),
                class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-font-bold", {
              'tw-text-blue-500': _ctx.editor && _ctx.editor.isActive('heading', { level: 3 })
            }]),
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().toggleHeading({ level: 3 }).run()))
              }, " h3 ", 10, _hoisted_15),
              _createElementVNode("button", {
                "data-testid": "toggle-editor-heading-4-button",
                disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleHeading({ level: 4 }).run()),
                class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-font-bold", {
              'tw-text-blue-500': _ctx.editor && _ctx.editor.isActive('heading', { level: 4 })
            }]),
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().toggleHeading({ level: 4 }).run()))
              }, " h4 ", 10, _hoisted_16),
              _createElementVNode("button", {
                "data-testid": "toggle-editor-heading-5-button",
                disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleHeading({ level: 5 }).run()),
                class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-font-bold", {
              'tw-text-blue-500': _ctx.editor && _ctx.editor.isActive('heading', { level: 5 })
            }]),
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().toggleHeading({ level: 5 }).run()))
              }, " h5 ", 10, _hoisted_17),
              _createElementVNode("button", {
                "data-testid": "toggle-editor-heading-6-button",
                disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleHeading({ level: 6 }).run()),
                class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-font-bold", {
              'tw-text-blue-500': _ctx.editor && _ctx.editor.isActive('heading', { level: 6 })
            }]),
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().toggleHeading({ level: 6 }).run()))
              }, " h6 ", 10, _hoisted_18)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTextAlignVariantButtons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                "data-testid": "toggle-editor-heading-1-button",
                disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleHeading({ level: 1 }).run()),
                class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-font-bold", {
              'tw-text-blue-500': _ctx.editor && _ctx.editor.isActive({ textAlign: 'left' })
            }]),
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().setTextAlign('left').run()))
              }, [
                _createVNode(_component_TablerAlignLeft, { class: "tw-h-4 tw-w-4" })
              ], 10, _hoisted_21),
              _createElementVNode("button", {
                "data-testid": "toggle-editor-heading-2-button",
                disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleHeading({ level: 2 }).run()),
                class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-font-bold", {
              'tw-text-blue-500': _ctx.editor && _ctx.editor.isActive({ textAlign: 'center' })
            }]),
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().setTextAlign('center').run()))
              }, [
                _createVNode(_component_TablerAlignCenter, { class: "tw-h-4 tw-w-4" })
              ], 10, _hoisted_22),
              _createElementVNode("button", {
                "data-testid": "toggle-editor-heading-3-button",
                disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleHeading({ level: 3 }).run()),
                class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-font-bold", {
              'tw-text-blue-500': _ctx.editor && _ctx.editor.isActive({ textAlign: 'right' })
            }]),
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().setTextAlign('right').run()))
              }, [
                _createVNode(_component_TablerAlignRight, { class: "tw-h-4 tw-w-4" })
              ], 10, _hoisted_23),
              _createElementVNode("button", {
                "data-testid": "toggle-editor-heading-4-button",
                disabled: !!(_ctx.editor && !_ctx.editor.can().chain().focus().toggleHeading({ level: 4 }).run()),
                class: _normalizeClass(["tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-font-bold", {
              'tw-text-blue-500': _ctx.editor && _ctx.editor.isActive({ textAlign: 'justify' })
            }]),
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.editor && _ctx.editor.chain().focus().setTextAlign('justify').run()))
              }, [
                _createVNode(_component_TablerAlignJustified, { class: "tw-h-4 tw-w-4" })
              ], 10, _hoisted_24)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_EditorContent, {
        id: _ctx.id,
        "data-testid": _ctx.id,
        editor: _ctx.editor as any,
        style: _normalizeStyle({
          'max-height': _ctx.maxHeight,
          'min-height': _ctx.minHeight,
          'overflow-y': 'scroll',
          'padding-left': '0.75rem',
          'padding-right': '0.75rem',
          'padding-top': '0.5rem',
          'padding-bottom': '0.5rem'
        })
      }, null, 8, ["id", "data-testid", "editor", "style"])
    ])
  ]))
}